import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tenantName = localStorage.getItem('__tenant');
    const tenantId = localStorage.getItem('tenantId');

    let headers = req.headers;

    if (tenantName && !headers.has('__tenant')) {
      headers = headers.set('__tenant', tenantName);
    }

    if (tenantId && !headers.has('__tenantid')) {
      headers = headers.set('__tenantid', tenantId);
    }

    let body = req.body;
    const isTokenRequest = req.url.toLowerCase().includes('/connect/token');

    if (isTokenRequest && body instanceof HttpParams) {
      if (tenantName && !body.has('__tenant')) {
        body = body.set('__tenant', tenantName);
      }

      if (tenantId && !body.has('__tenantid')) {
        body = body.set('__tenantid', tenantId);
      }
    }

    const authReq = req.clone({ headers, body });
    return next.handle(authReq);
  }
}
